module.exports = __webpack_public_path__ + "media/images/meta/cyclebar/favicon-45d52c1f07acfa9ccad9be020e119180.png";